'use client';

import React from 'react';

import { getDealershipsPagePaths } from '@/services/link.service';
import { ChildFilter, ParentFilter } from '@/types/filters/filters.types';

import { LandingChildrenList } from './landing-children-list';

export const LandingChildrenListClient: React.FC<{
  activeParent?: ParentFilter;
  activeChild?: ChildFilter;
  title?: string | React.ReactNode;
  activeChildAs?: string;
}> = ({ activeParent, activeChild, title, activeChildAs }) => {
  return (
    <LandingChildrenList
      activeParent={activeParent}
      activeChild={activeChild}
      title={title}
      activeChildAs={activeChildAs}
      getChildLink={getDealershipsPagePaths}
    />
  );
};
